import type {DoppeActionCTAButton} from './doppe-action-cta-button';
import {assertDefined} from '@wix/devzai-utils-common';
import {doppeActionCtaMultipleButtonExtendWithDefaultValues} from './doppe-action-cta-button-settings';

export interface DoppeActionCtaButtonsSettings {
    ctaButtons: DoppeActionCTAButton.MultipleButton[];
}

export function doppeActionCtaButtonsSettingsDefaultValuesMigration(ctaButtonsSettings: Partial<DoppeActionCtaButtonsSettings>, hasSourceURL: boolean) {
    return {
        ctaButtons: ctaButtonsSettings?.ctaButtons ? ctaButtonsSettings.ctaButtons.map(ctaButton => {
            return assertDefined(doppeActionCtaMultipleButtonExtendWithDefaultValues({
                ctaButton: ctaButton,
                hasSourceURL: hasSourceURL
            }))
        }) : []
    } satisfies DoppeActionCtaButtonsSettings
}

export function doppeActionCtaButtonsSettingsHasVisibleButton(ctaButtonsSettings: DoppeActionCtaButtonsSettings) {
    return ctaButtonsSettings.ctaButtons.length > 0 && ctaButtonsSettings.ctaButtons.some(ctaButton => ctaButton.isVisible);
}

export function doppeActionCtaButtonsSettingsGetVisibleButtonsCount(ctaButtons: DoppeActionCTAButton.MultipleButton[]) {
    return ctaButtons.filter(ctaButton => ctaButton.isVisible).length;
}


